/* ============================================================
   Trident Filter Sidebar (Direction B) — progressive enhancement.

   The Shopify theme re-renders the filter forms on every AJAX
   filter change, so all behaviour here is delegated from `document`
   and reads state from the DOM. No per-render initialisation is
   needed; nothing here owns state that must survive a swap.

   Handles:
     - global "find a filter" search (narrows facets + values)
     - search-within a single long facet
     - show-all / show-less for long facet lists
     - price histogram highlight synced to the range slider
   Selection itself is left to the native filter.* inputs so the
   theme's existing server-side filtering keeps working untouched.
   ============================================================ */
(function () {
  'use strict';

  var norm = function (s) { return (s || '').toString().trim().toLowerCase(); };

  function expandFacet(facet) {
    var head = facet.querySelector('.tff-facet__head[aria-controls]');
    var body = facet.querySelector('.collection__filter-collapsible');
    if (head && body && head.getAttribute('aria-expanded') !== 'true') {
      head.setAttribute('aria-expanded', 'true');
      body.setAttribute('aria-hidden', 'false');
      body.style.height = 'auto';
      body.style.overflow = 'visible';
    }
  }

  // Show / hide individual option rows + chips within a facet to match `q`.
  // apply=false clears the filter (every option visible again).
  function filterFacetValues(facet, q, apply) {
    facet.querySelectorAll('.tff-row').forEach(function (row) {
      if (!apply) { row.classList.remove('tff-row--hide'); return; }
      var hit = norm(row.getAttribute('data-tff-label')).indexOf(q) !== -1;
      row.classList.toggle('tff-row--hide', !hit);
    });
    facet.querySelectorAll('.tff-pill').forEach(function (pill) {
      if (!apply) { pill.classList.remove('tff-pill--hide'); return; }
      var hit = norm(pill.getAttribute('data-tff-label')).indexOf(q) !== -1;
      pill.classList.toggle('tff-pill--hide', !hit);
    });
    facet.classList.toggle('tff-value-filtered', !!apply);
  }

  /* ---------- global find-a-filter (matches facet names AND option values) ---------- */
  function runFind(input) {
    var root = input.closest('.tff-filters');
    if (!root) return;
    var q = norm(input.value);
    var find = input.closest('.tff-find');
    if (find) find.classList.toggle('is-filled', q.length > 0);

    var facets = root.querySelectorAll('[data-tff-facet]');
    var anyVisible = false;

    facets.forEach(function (facet) {
      if (!q) {
        facet.classList.remove('tff-hidden');
        filterFacetValues(facet, '', false);
        anyVisible = true;
        return;
      }
      var nameMatch = norm(facet.getAttribute('data-tff-name')).indexOf(q) !== -1;
      var valueMatch = false;
      if (!nameMatch) {
        var labels = facet.querySelectorAll('[data-tff-label]');
        for (var i = 0; i < labels.length; i++) {
          if (norm(labels[i].getAttribute('data-tff-label')).indexOf(q) !== -1) { valueMatch = true; break; }
        }
      }

      if (nameMatch) {
        // whole facet matches by name -> show it with every option
        facet.classList.remove('tff-hidden');
        filterFacetValues(facet, '', false);
        anyVisible = true;
      } else if (valueMatch) {
        // matched on an option value -> show the facet, narrowed to matching options
        facet.classList.remove('tff-hidden');
        filterFacetValues(facet, q, true);
        expandFacet(facet);
        anyVisible = true;
      } else {
        facet.classList.add('tff-hidden');
        filterFacetValues(facet, '', false);
      }
    });

    root.classList.toggle('is-find-empty', !anyVisible && q.length > 0);
  }

  /* ---------- search within a single facet ---------- */
  function runFacetSearch(input) {
    var list = input.closest('[data-tff-list]');
    if (!list) return;
    var q = norm(input.value);
    var search = input.closest('.tff-facet-search');
    var clearBtn = search ? search.querySelector('[data-tff-facet-search-clear]') : null;
    if (clearBtn) clearBtn.hidden = q.length === 0;

    list.classList.toggle('is-searching', q.length > 0);
    var rows = list.querySelectorAll('.tff-row');
    var shown = 0;
    rows.forEach(function (row) {
      if (!q) { row.classList.remove('tff-row--hide'); return; }
      var hit = norm(row.getAttribute('data-tff-label')).indexOf(q) !== -1;
      row.classList.toggle('tff-row--hide', !hit);
      if (hit) shown++;
    });

    var empty = list.querySelector('[data-tff-empty]');
    if (empty) empty.hidden = !(q && shown === 0);
  }

  /* ---------- price histogram highlight ---------- */
  function syncHistogram(priceFacet) {
    var hist = priceFacet.querySelector('[data-tff-hist]');
    var group = priceFacet.querySelector('.price-range__range-group');
    if (!hist || !group) return;
    var ranges = group.querySelectorAll('input[type="range"]');
    if (ranges.length < 2) return;
    var lo = parseFloat(ranges[0].value);
    var hi = parseFloat(ranges[1].value);
    var max = parseFloat(ranges[0].max) || 1;
    if (lo > hi) { var t = lo; lo = hi; hi = t; }
    var bars = hist.querySelectorAll('.tff-hist__bar');
    var n = bars.length;
    bars.forEach(function (bar, i) {
      var bLo = (i / n) * max;
      var bHi = ((i + 1) / n) * max;
      bar.classList.toggle('is-on', bHi > lo && bLo < hi);
    });
  }

  function syncAllHistograms(scope) {
    (scope || document).querySelectorAll('.tff-facet--price').forEach(syncHistogram);
  }

  /* ---------- delegated listeners (survive AJAX swaps) ---------- */
  document.addEventListener('input', function (e) {
    var t = e.target;
    if (!t) return;
    if (t.matches('[data-tff-find]')) { runFind(t); return; }
    if (t.matches('[data-tff-facet-search]')) { runFacetSearch(t); return; }
    if (t.matches('.price-range__range-group input[type="range"]')) {
      var pf = t.closest('.tff-facet--price');
      if (pf) syncHistogram(pf);
    }
  });

  document.addEventListener('click', function (e) {
    var more = e.target.closest('[data-tff-more]');
    if (more) {
      e.preventDefault();
      var list = more.closest('[data-tff-list]');
      if (!list) return;
      var expanded = list.classList.toggle('is-expanded');
      more.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      var show = more.querySelector('[data-tff-more-show]');
      var hide = more.querySelector('[data-tff-more-hide]');
      if (show) show.hidden = expanded;
      if (hide) hide.hidden = !expanded;
      return;
    }

    var clr = e.target.closest('[data-tff-facet-search-clear]');
    if (clr) {
      e.preventDefault();
      var search = clr.closest('.tff-facet-search');
      var input = search ? search.querySelector('[data-tff-facet-search]') : null;
      if (input) { input.value = ''; runFacetSearch(input); input.focus(); }
      return;
    }

    var findClr = e.target.closest('.tff-find__x');
    if (findClr) {
      e.preventDefault();
      var fInput = findClr.closest('.tff-find').querySelector('[data-tff-find]');
      if (fInput) { fInput.value = ''; runFind(fInput); fInput.focus(); }
    }
  });

  /* ---------- keep histograms correct on first paint + after swaps ---------- */
  function boot() { syncAllHistograms(document); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  // the theme replaces filter form innerHTML on AJAX; re-sync when that happens
  var debounce;
  var mo = new MutationObserver(function () {
    clearTimeout(debounce);
    debounce = setTimeout(function () { syncAllHistograms(document); }, 50);
  });
  function observeForms() {
    ['desktop-filters-form', 'mobile-collection-filters'].forEach(function (id) {
      var el = document.getElementById(id);
      if (el) mo.observe(el, { childList: true, subtree: true });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeForms);
  } else {
    observeForms();
  }
})();
